import { Navigation } from "@/components/Navigation";
import { Hero } from "@/components/Hero";
import { Story } from "@/components/Story";
import { IsThisYou } from "@/components/IsThisYou";
import { ContentHub } from "@/components/ContentHub";
import { SevenSignsOptIn } from "@/components/SevenSignsOptIn";
import { NewsletterSignup } from "@/components/NewsletterSignup";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";
import { organizationSchema, websiteSchema } from "@/lib/structuredData";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { trackCta } from "@/lib/trackCta";

const Index = () => {
  const combinedSchema = {
    "@context": "https://schema.org",
    "@graph": [organizationSchema, websiteSchema]
  };

  return (
    <div className="min-h-screen">
      <SEO
        title="Rob Lasa — Honest reflections from the middle"
        description="One man's honest record of what happens when you stop performing. For my sons. For any man who sees himself in it."
        keywords="nice guy syndrome, men's mental health, honest masculinity, identity, self-honesty"
        url="/"
        schema={combinedSchema}
      />
      <Navigation />
      <main>
        <Hero />
        <Story />
        <IsThisYou />
        <SevenSignsOptIn />
        <ContentHub />

        {/* Nice Guy Trap Teaser */}
        <section className="py-24 bg-gradient-hero relative">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center space-y-8">
              <h2 className="font-display text-4xl md:text-5xl font-bold text-primary-foreground">
                Being Nice Almost <span className="text-accent">Killed Me</span>
              </h2>
              <p className="text-xl text-primary-foreground/90 max-w-2xl mx-auto leading-relaxed">
                I spent decades being the nice guy. Saying yes when I meant no. 
                Performing kindness to avoid conflict. It cost me everything real.
              </p>
              <Button asChild size="lg" className="bg-accent text-white hover:bg-accent/90">
                <Link to="/nice-guy" onClick={() => trackCta("home_nice_guy_teaser", "/nice-guy", "Read the Full Story")}>
                  Read the Full Story
                </Link>
              </Button>
            </div>
          </div>
        </section>

        <NewsletterSignup />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
